/** Small JSON client for the Agora API. Cookies carry the session. */
export class ApiError extends Error {
  constructor(
    message: string,
    readonly status: number,
    readonly code?: string,
    readonly data?: Record<string, unknown>,
  ) {
    super(message);
  }
}

export async function api<T = Record<string, unknown>>(path: string, body?: unknown, method?: "GET" | "POST" | "PUT" | "PATCH" | "DELETE"): Promise<T> {
  const verb = method ?? (body === undefined ? "GET" : "POST");
  const res = await fetch(path, {
    method: verb,
    credentials: "same-origin",
    headers: body === undefined ? {} : { "Content-Type": "application/json" },
    body: body === undefined ? undefined : JSON.stringify(body),
  });
  const data = (await res.json().catch(() => ({}))) as Record<string, unknown>;
  if (!res.ok) {
    const message = typeof data.error === "string" ? data.error : "Something went wrong. Please try again.";
    throw new ApiError(message, res.status, typeof data.code === "string" ? data.code : undefined, data);
  }
  return data as T;
}

export interface Me {
  user: {
    id: string;
    name: string;
    email: string;
    avatarUrl: string | null;
    emailVerified: boolean;
    hasPassword: boolean;
    google: boolean;
    createdAt: string;
    lastSeenAt: string | null;
  };
  workspaces: { id: string; name: string; role: "admin" | "member" | "guest" }[];
}

export interface AuthOptions {
  google: boolean;
  firstRun: boolean;
}
